export const timeline = {
today: "Hoy",
yesterday: "Ayer",
emptyTitle: "Aún no hay actividad",
emptySub: "Los eventos de este flujo aparecerán aquí cuando ocurran.",
filters: {
  contact: "Contacto",
all: "Todos",
asset: "Activo",
inspection: "Inspección",
job: "Orden de trabajo",
request: "Solicitud",
report: "Informe",
},
summary: {
label: "Resumen IA",
sinceToggle: "Desde mi última visita",
btnSummarise: "Resumir",
btnRegenerate: "Regenerar",
btnLoading: "Resumiendo…",
loading: "Leyendo la cronología…",
emptyHint: "Pulsa Resumir para obtener un resumen de 2-4 frases de este activo.",
emptyHintSite: "Pulsa Resumir para obtener un resumen de 2-4 frases de este sitio.",
emptyHintContact: "Pulsa Resumir para obtener un resumen de 2-4 frases de este contacto.",
errorFallback: "No se pudo cargar el resumen. Inténtalo de nuevo.",
},
events: {
assetCreated: "Activo creado",
inspectionStarted: "Inspección iniciada",
inspectionCompleted: "Inspección completada",
issueRaised: "Incidencia registrada",
requestRaised: "Solicitud creada",
approvalReceived: "Aprobación recibida",
quoteReceived: "Presupuesto recibido",
jobCreated: "Orden de trabajo creada",
jobAssigned: "Orden de trabajo asignada",
workCompleted: "Trabajo finalizado",
evidenceAdded: "Evidencia añadida",
reportGenerated: "Informe generado",
},
};
